import React, {Component} from "react";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";
import {LayoutSplashScreen} from "../../../../_metronic/layout";
import * as auth from "../_redux/authRedux";
// import { RemoveCookies } from "../../../../_metronic/_helpers/Cookies";
import { BASE_URL } from "./../../../../env_config"
class Logout extends Component {
  componentDidMount() {
    this.props.logout();
    localStorage.clear()
    var cookies = document.cookie.split(";");
for(var i=0; i < cookies.length; i++) {
  if(cookies[i] && !cookies[i].includes("view")){
    var equals = cookies[i].indexOf("=");
    var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}
    window.location.replace(`${BASE_URL}/logout`);
  }

  render() {
    const { hasAuthToken } = this.props;
    return hasAuthToken ? <LayoutSplashScreen /> : <Redirect to="/auth/login" />;
  }
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
  auth.actions
)(Logout);
